/**
 * Get the label name for the legend
 *
 * @return {string}
 */

export const renderLegend = (value, entry) => {
  return <span className={`cell-${value}`}>{entry.payload.label}</span>;
};
